import { partition, wrapSides } from "@thi.ng/transducers";
export const edgeIterator = (vertices, closed = false) => (partition(2, 1, closed ? wrapSides(vertices, 0, 1) : vertices));
